// Services
import userService from '@/app/services/main/user/user-service';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

export const userMixins = {
	mixins: [
		toastMessageMixins
	],
	computed: {
		userDetails() {
			return this.$store.getters.getUserDetails;
		},
		getActivePet() {
			return this.$store.getters.getActivePet;
		},
		getUserName() {
			const {firstName, lastName} = this.getUserDetails();

			return `${firstName} ${lastName}`;
		},
		getUserEmail() {
			const { emailAddress }	= this.getUserDetails();

			return emailAddress;
		},
		getUserInitial() {
			const {firstName, lastName} = this.getUserDetails();
			let userInitials = '';

			if (firstName && lastName) {
				userInitials = 	`${firstName.charAt(0)}${lastName.charAt(0)}`
			}

			return userInitials;
		},
		getUserPets() {
			const { pets } = this.getUserDetails();

			return pets;
		},
		getActivePetBreed() {
			const { name: breedName } = this.getActivePet.breed;

			return breedName;
		},
		userId() {
			const { id } = this.getUserDetails();

			return id;
		},
		userRole() {
			const { userRole } = this.getUserDetails();

			return userRole;
		},
		getAddressSearch() {
			const { addressSearch, latSearch, longSearch } = this.$store.getters.getUserDetails;

			return { addressSearch, latSearch, longSearch };
		}
	},
	methods: {
		getUserDetails() {
			const { firstName, lastName, pets, emailAddress, customerId, id, userRole, address, mobileNumber } = this.$store.getters.getUserDetails;

			return { firstName, lastName, pets, emailAddress, customerId, id, userRole, address, mobileNumber};
		},
		hasPetImage(index) {
			let hasImage = false;

			if (this.getUserPets) {
				if (this.getUserPets[index]) {
					hasImage = !!this.getUserPets[index].imageUrl;
				}
			}

			return hasImage;
		},
		getPetImage(index, isForActivePet, imageUrl) {
			let petImage = require('@/assets/images/_shared/dog-smile.svg');

			if (isForActivePet && imageUrl) {
				petImage = imageUrl;
			} else {
				if (this.hasPetImage(index)) {
					petImage = this.getUserPets[index].imageUrl;
				}
			}

			return petImage;
		},
		getUserDetailsAPI(isPetUpdated = false, updatedPetId = null, isPetDeleted = false) {
			this.isAPILoading = true;
			const { emailAddress } = this.getUserDetails();

			// lmdc get logged in user api
			return userService.getLoggedInUser(emailAddress)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.$store.commit('setUserDetails', res.data.userDetails);

						if (isPetUpdated) {
							const updatedActivePet = res.data.userDetails.pets.find(pet => pet.id === updatedPetId);
							this.$store.commit('setActivePet', updatedActivePet);
						} else if (isPetDeleted) {
							this.$store.commit('setActivePet', res.data.userDetails.pets[0]);
							this.$router.push('/dashboard');
							this.$router.go(this.$router.currentRoute)
						}
					} else {
						this.showGenericErrorToast();
					}

					this.isAPILoading = false;
				});
		}
	}
}